var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStumbrastechLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 1024",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.542 222.67C203.833 235.281 206.216 255.909 205.542 273.121C205.006 286.817 199.599 304.648 197.415 313.399C193.322 329.791 176.237 348.212 170.547 354.51C164.324 361.397 169.033 355.913 153.099 369.657",
    fill: "none",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 33.7829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.819 222.67C202.692 226.911 199.169 227.65 199.169 227.65C199.169 227.65 182.155 240.932 182.155 240.932C182.155 240.932 147.584 268.992 126.325 309.848C103.555 353.608 96.5263 412.152 116.595 456.177C166.929 566.597 369.287 601.292 289.685 760.042",
    fill: "none",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 33.7829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.933 759.308C384.186 727.083 395.111 797.312 433.184 855.702",
    fill: "none",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 33.7829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.188 614.979C328.311 501.386 313.88 396.292 367.764 348.307C401.335 318.411 480.576 275.463 480.576 275.463C480.576 275.463 575.352 213.787 642.351 213.956C675.12 214.039 737.887 263.736 757.421 291.64C762.215 298.489 764.048 308.155 764.048 308.155L764.772 318.88C764.772 318.88 761.492 342.112 763.277 357.479C764.317 366.425 766.187 375.21 768.311 385.217C768.957 388.26 769.637 387.963 772.513 390.591C778.099 395.694 784.816 399.613 784.816 399.613L799.379 407.869C799.379 407.869 831.038 417.421 844.192 410.7C853.226 406.084 861.976 397.708 861.888 387.564C861.595 354.013 858.778 318.626 868.552 285.845C878.393 252.841 887.083 219.018 899.638 186.817C900.398 184.87 907.923 166.037 907.923 166.037C907.923 166.037 912.508 150.124 911.17 149.469C900.798 144.396 873.651 165.225 873.651 165.225C873.651 165.225 856.785 180.57 843.844 192.109C832.418 202.296 806.717 245.077 806.717 245.077C806.717 245.077 794.882 271.75 798.126 279.141C830.467 352.821 958.447 319.769 986.696 347.529C987.991 348.801 990.973 472.58 992.208 486.999C993.526 502.372 994.039 568.858 988.658 574.334C966.181 597.206 933.374 584.941 911.011 630.66C903.565 645.882 899.503 670.679 895.987 687.183C894.09 696.086 885.68 676.122 881.538 668.016C877.228 659.581 866.614 650.497 855.104 648.567C833.153 644.886 812.144 644.118 789.463 671.051C761.028 704.817 771.653 778.426 790.201 810.237C794.397 817.433 823.208 875.327 823.208 875.327",
    fill: "none",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 33.7829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9173 875.327C41.8101 874.538 66.0184 875.327 79.2087 875.327C99.902 875.327 124.462 825.43 124.462 825.43L161.085 765.207C161.085 765.207 212.544 682.085 295.933 641.744M375.491 617.131C397.724 611.012 401.065 608.227 420.012 610.332C473.701 616.298 521.513 650.207 546.648 696.886C555.358 713.062 562.972 731.631 565.237 749.747C566.272 758.029 567.586 774.717 574.531 770.087C638.005 727.771 692.757 803.446 720.448 832.989C720.448 832.989 744.963 865.558 754.867 868.696C773.181 874.499 808.994 875.327 822.029 875.327",
    fill: "none",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 33.7829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.158 421.808C289.948 425.007 269.396 440.952 266.214 444.283C247.517 463.854 177.689 509.155 175.276 521.032C169.932 547.337 192.398 583.2 175.467 610.979C172.336 616.117 166.487 625.601 166.487 625.601C166.487 625.601 159.152 637.256 142.987 647.866C92.6363 680.911 59.1905 819.66 30.9173 875.327",
    fill: "none",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 33.7829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.782 810.237C417.468 829.609 423.904 850.342 444.172 865.61C452.893 872.18 464.851 872.898 475.877 875.327",
    fill: "none",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeWidth: 33.7829
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStumbrastechLogo);
export default __webpack_public_path__ + "static/media/stumbrastech_logo.8a26aa3ee53f9d1a4fe499a2cd0dadc5.svg";
export { ForwardRef as ReactComponent };